export const swiperInit = () => {
  const featuresConfirmSelector = document.querySelector(
    ".features-confirm__slider"
  );

  if (featuresConfirmSelector) {
    let featuresConfirmSlider;

    if (window.innerWidth > 560 && !featuresConfirmSlider) {
      featuresConfirmSlider = new Swiper(featuresConfirmSelector, {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    } else if (window.innerWidth <= 560 && featuresConfirmSlider) {
      featuresConfirmSlider.destroy(true, true); // Уничтожаем слайдер
      featuresConfirmSlider = null;
    }
  }

  const practiceSliderSelector = document.querySelector(".practice__slider");

  if (practiceSliderSelector) {
    const practiceSlider = new Swiper(practiceSliderSelector, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: {
          // ≥320px
          slidesPerView: 1,
          spaceBetween: 15,
        },
        700: {
          // ≥700px
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          // ≥1024px
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    });

    document
      .querySelector(".practice__slider_prev")
      .addEventListener("click", () => {
        practiceSlider.slidePrev();
      });

    document
      .querySelector(".practice__slider_next")
      .addEventListener("click", () => {
        practiceSlider.slideNext();
      });
  }

  const facultiesSliderSelector = document.querySelector(".faculties__slider");

  if (facultiesSliderSelector) {
    const facultiesSlider = new Swiper(facultiesSliderSelector, {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: {
          // ≥320px
          slidesPerView: 1,
          spaceBetween: 15,
        },
        700: {
          // ≥700px
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          // ≥1024px
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    });

    document
      .querySelector(".faculties__slider_prev")
      .addEventListener("click", () => {
        facultiesSlider.slidePrev();
      });

    document
      .querySelector(".faculties__slider_next")
      .addEventListener("click", () => {
        facultiesSlider.slideNext();
      });
  }

  const feedbackSliderSelector = document.querySelector(".feedback__slider");

  if (feedbackSliderSelector) {
    const feedbackSlider = new Swiper(feedbackSliderSelector, {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        init: function () {
          let maxHeight = 0;
          feedbackSliderSelector
            .querySelectorAll(".swiper-slide")
            .forEach((slide) => {
              maxHeight = Math.max(maxHeight, slide.offsetHeight);
            });
          feedbackSliderSelector.querySelector(".swiper-wrapper").style.height =
            maxHeight + "px";
        },
      },
      breakpoints: {
        320: {
          // ≥320px
          slidesPerView: 1,
          spaceBetween: 15,
        },
        700: {
          // ≥700px
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          // ≥1024px
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    });

    document
      .querySelector(".feedback__slider_prev")
      .addEventListener("click", () => {
        feedbackSlider.slidePrev();
      });

    document
      .querySelector(".feedback__slider_next")
      .addEventListener("click", () => {
        feedbackSlider.slideNext();
      });
  }

  const returnSwiper = document.querySelector(".returnSwiper");

  if (returnSwiper) {
    const returnSwiperInit = new Swiper(returnSwiper, {
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: true,
      allowTouchMove: false,
    });

    const nextSlideTriggers = document.querySelectorAll("[data-return-next]");
    nextSlideTriggers.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const currentSlide =
          returnSwiperInit.slides[returnSwiperInit.activeIndex];
        const inputs = currentSlide.querySelectorAll(
          "input[type='radio']:checked, input[type='text'], input[type='tel']"
        );

        if (currentSlide.querySelector(".return-block__radio")) {
          // Проверяем, что выбран хотя бы один радио-инпут
          if (!currentSlide.querySelector("input[type='radio']:checked")) {
            alert("Будь ласка, виберіть один з варіантів!");
            return;
          }
        } else if (currentSlide.querySelector(".return-block__final")) {
          // Проверяем, что заполнены текстовые инпуты
          const name = currentSlide.querySelector("input[name='name']");
          const phone = currentSlide.querySelector("input[name='tel']");

          if (!name.value.trim()) {
            alert("Будь ласка, введіть ваше ім'я!");
            return;
          }
          if (!phone.value.trim()) {
            alert("Будь ласка, введіть ваш номер телефону!");
            return;
          }
        }

        returnSwiperInit.slideNext();
      });
    });

    const prevSlideTriggers = document.querySelectorAll("[data-return-prev]");
    prevSlideTriggers.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        returnSwiperInit.slidePrev();
      });
    });
  }
};
